export const topicsData = [
  { id: 1, tag: "顶流塌房", heat: "987万", trend: "up", slug: "top-star-scandal" },
  { id: 2, tag: "选秀内幕", heat: "856万", trend: "up", slug: "talent-show-insider" },
  { id: 3, tag: "恋情实锤", heat: "743万", trend: "up", slug: "romance-evidence" },
  { id: 4, tag: "综艺翻车", heat: "692万", trend: "hot", slug: "variety-flip" },
  { id: 5, tag: "税务风波", heat: "621万", trend: "up", slug: "tax-scandal" },
  { id: 6, tag: "假唱现场", heat: "588万", trend: "down", slug: "lip-sync" },
  { id: 7, tag: "代言解约", heat: "534万", trend: "up", slug: "endorsement-cancel" },
  { id: 8, tag: "私生饭事件", heat: "487万", trend: "hot", slug: "sasaeng-incident" },
  { id: 9, tag: "剧组矛盾", heat: "452万", trend: "up", slug: "crew-conflict" },
  { id: 10, tag: "社交删帖", heat: "419万", trend: "up", slug: "social-delete" },
  { id: 11, tag: "后台潜规则", heat: "386万", trend: "hot", slug: "backstage-rules" },
];

export const updatesData = [
  { id: 1, time: "10分钟前", title: "某顶流工作室紧急发布律师函，否认近日网络传言", tag: "最新" },
  { id: 2, time: "28分钟前", title: "综艺录制现场突发状况，导演组紧急叫停拍摄", tag: "突发" },
  { id: 3, time: "1小时前", title: "知名品牌连夜撤下代言人物料，疑似合约纠纷", tag: "跟进" },
  { id: 4, time: "2小时前", title: "选秀节目导师组内部矛盾曝光，录制一度中断", tag: "独家" },
  { id: 5, time: "3小时前", title: "多位业内人士发声力挺，事件持续发酵", tag: "热点" },
  { id: 6, time: "5小时前", title: "税务部门回应：相关信息正在核查中", tag: "官方" },
  { id: 7, time: "7小时前", title: "粉丝后援会发布联合声明，要求公开真相", tag: "热议" },
  { id: 8, time: "9小时前", title: "知情人士爆料：合同细节存在重大争议", tag: "内幕" },
  { id: 9, time: "12小时前", title: "社交平台相关话题阅读量突破3亿", tag: "数据" },
];

export const cardsData = [
  {
    id: 1,
    title: "某顶流艺人被曝税务问题，涉及金额超千万",
    excerpt: "据知情人士透露，该艺人名下多家公司存在账目异常，税务部门已介入调查。此事在圈内引起轩然大波，多位与其有合作的品牌方已紧急启动应急预案。",
    image: "https://readdy.ai/api/search-image?query=Breaking%20news%20concept%20with%20dramatic%20red%20lighting%2C%20newspaper%20headlines%2C%20mysterious%20silhouette%2C%20investigative%20journalism%20atmosphere%2C%20dark%20moody%20background%20with%20warm%20accents%2C%20editorial%20photography%20style&width=800&height=500&seq=card-news-01&orientation=landscape",
    tag: "独家爆料",
    date: "2026-07-30",
  },
  {
    id: 2,
    title: "选秀节目导师阵容内幕：片酬差距悬殊引争议",
    excerpt: "某热门选秀节目最新一季导师片酬遭曝光，最高与最低之间相差近10倍。节目组回应称片酬根据市场价值和档期综合评估，不存在不公平待遇。",
    image: "https://readdy.ai/api/search-image?query=Television%20studio%20stage%20with%20dramatic%20spotlights%2C%20empty%20judges%20chairs%2C%20show%20business%20atmosphere%2C%20warm%20golden%20and%20red%20lighting%2C%20entertainment%20industry%20photography&width=800&height=500&seq=card-news-02&orientation=landscape",
    tag: "行业揭秘",
    date: "2026-07-29",
  },
  {
    id: 3,
    title: "顶流恋情再添实锤：同款饰品与行程高度重合",
    excerpt: "网友扒出两位顶流艺人近半年来佩戴多款同款饰品，且多个城市行程高度重合。双方工作室均未对此作出回应，粉丝评论区已炸锅。",
    image: "https://readdy.ai/api/search-image?query=Elegant%20jewelry%20and%20accessories%20on%20dark%20velvet%20background%2C%20mysterious%20romantic%20atmosphere%2C%20soft%20warm%20lighting%2C%20luxury%20fashion%20editorial%20style&width=800&height=500&seq=card-news-03&orientation=landscape",
    tag: "恋情曝光",
    date: "2026-07-29",
  },
  {
    id: 4,
    title: "综艺录制现场突发意外，嘉宾当场罢录离场",
    excerpt: "某竞技类综艺最新一期录制中，两位嘉宾因游戏环节发生激烈争执，其中一人当场摔麦离开。节目组紧急暂停录制，后续是否继续合作尚未确定。",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20TV%20studio%20with%20empty%20microphone%20on%20floor%2C%20tension%20atmosphere%2C%20dark%20stage%20with%20single%20spotlight%2C%20behind%20the%20scenes%20drama%20photography&width=800&height=500&seq=card-news-04&orientation=landscape",
    tag: "综艺翻车",
    date: "2026-07-28",
  },
  {
    id: 5,
    title: "经纪公司内部邮件泄露：艺人管理存在严重问题",
    excerpt: "一份据称来自某大型经纪公司的内部邮件在网络流传，内容直指公司对艺人的过度管控和不合理条款。法律人士表示如邮件属实，涉事公司可能面临集体诉讼。",
    image: "https://readdy.ai/api/search-image?query=Confidential%20documents%20and%20envelope%20on%20dark%20desk%2C%20investigative%20mood%2C%20dramatic%20shadows%2C%20corporate%20leak%20concept%2C%20warm%20desk%20lamp%20lighting&width=800&height=500&seq=card-news-05&orientation=landscape",
    tag: "内部爆料",
    date: "2026-07-28",
  },
];

export const faqData = [
  {
    id: 1,
    q: "五一黑料网的内容来源可靠吗？",
    a: "我们整合多渠道信息来源，包括行业内部人士爆料、公开新闻报道和网友投稿，所有内容均标注来源类型。对于未经证实的消息，我们会明确标注「待核实」，建议读者理性看待。",
  },
  {
    id: 2,
    q: "如何向五一黑料网投稿或提供线索？",
    a: "您可以通过页面底部的「联系我们」模块提交线索或投稿。我们承诺对所有提供线索的用户进行严格匿名保护，绝不泄露投稿人任何信息。",
  },
  {
    id: 3,
    q: "五一黑料网的内容更新频率如何？",
    a: "我们保持7x24小时内容更新，重大事件15分钟内响应。每日推送热点汇总和独家深度内容，确保您不会错过任何一个瓜。",
  },
  {
    id: 4,
    q: "网站上的内容是否经过核实？",
    a: "我们设有专门的核实团队，对每条信息进行分类标记：已核实、多方印证、待核实、网友投稿。建议读者关注标注信息，结合多方信息综合判断。",
  },
  {
    id: 5,
    q: "五一黑料网与其他娱乐资讯平台有何不同？",
    a: "我们坚持「不做搬运工，只挖真内幕」的理念，深度挖掘事件背后的真相。同时我们提供时间线梳理、人物关系图谱等专业内容，帮助读者全面了解事件全貌。",
  },
];

export const commentsData = [
  {
    id: 1,
    avatar: "匿",
    name: "吃瓜一线群众",
    time: "5分钟前",
    content: "这个瓜我蹲了三天了，终于等到实锤！五一黑料网的跟进速度真的没得说，比那些大平台快多了。坐等后续更多细节曝光。",
    likes: 2836,
  },
  {
    id: 2,
    avatar: "匿",
    name: "圈内小透明",
    time: "18分钟前",
    content: "作为一个行业从业者，我只能说这里面水太深了。网站曝出来的只是冰山一角，真正的大瓜还在后面。建议大家持续关注。",
    likes: 1954,
  },
  {
    id: 3,
    avatar: "匿",
    name: "理性吃瓜人",
    time: "42分钟前",
    content: "建议大家理性看待，目前还没有官方回应，不要被带节奏。不过这种持续性的爆料确实让人不得不怀疑背后有人在推。拭目以待吧。",
    likes: 1521,
  },
  {
    id: 4,
    avatar: "匿",
    name: "夜猫子追瓜",
    time: "1小时前",
    content: "凌晨三点还在刷新首页，就为了蹲第一手消息。五一黑料网现在是我每天的必刷站，信息又快又全，吃瓜就靠它了。",
    likes: 987,
  },
];

export const aboutData = {
  title: "关于五一黑料网",
  content: "五一黑料网诞生于2024年，是国内领先的娱乐八卦与行业爆料聚合平台。我们致力于为吃瓜群众提供最新、最全、最深的娱乐圈内幕与热点事件追踪。从瓜田爆料到黑料内幕，从吃瓜事件到今日黑料，我们的团队7x24小时不间断监测全网动态，第一时间为您呈现最有料的内容。平台覆盖顶流明星、综艺节目、影视剧组、品牌代言、选秀赛事等多个领域，以深度挖掘和独家视角立足行业。我们坚持内容为王，拒绝标题党，每条信息均标注来源与核实状态，让读者在享受吃瓜乐趣的同时保持理性判断。",
  stats: [
    { label: "日活用户", value: "280万+" },
    { label: "日均爆料", value: "500+条" },
    { label: "独家内容", value: "3200+篇" },
  ],
};

export const appData = {
  title: "随时随地，吃瓜不停",
  subtitle: "下载五一黑料网APP，第一时间接收最新瓜田推送",
  features: ["实时推送 · 重大爆料不错过", "离线阅读 · 没网也能看爆料", "评论互动 · 和千万吃瓜群众一起讨论", "投稿便捷 · 手机一键提交线索"],
  qrImage: "https://readdy.ai/api/search-image?query=Minimalist%20QR%20code%20design%20on%20clean%20white%20background%2C%20modern%20app%20download%20concept%2C%20subtle%20warm%20red%20accents%2C%20simple%20graphic%20design&width=400&height=400&seq=app-qr-code&orientation=squarish",
};

export const rankingData = [
  { rank: 1, title: "顶流艺人税务问题持续发酵，合作品牌连夜解约", heat: "987万", change: "up" },
  { rank: 2, title: "选秀节目内幕大起底：导师片酬相差近10倍", heat: "856万", change: "up" },
  { rank: 3, title: "综艺录制现场嘉宾冲突，节目组紧急叫停", heat: "743万", change: "new" },
  { rank: 4, title: "经纪公司内部邮件泄露，艺人合同条款遭质疑", heat: "692万", change: "up" },
  { rank: 5, title: "顶流恋情再添实锤，同款穿搭引热议", heat: "621万", change: "down" },
  { rank: 6, title: "知名歌手被质疑假唱，演出视频全网疯传", heat: "588万", change: "up" },
];

export const carouselData = [
  {
    id: 1,
    title: "顶流塌房全记录",
    subtitle: "2026上半年娱乐圈大事件盘点",
    excerpt: "从年初的税务风波到最近的恋情曝光，我们梳理了上半年最轰动的娱乐圈大事件，一文看懂所有来龙去脉。",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20red%20curtain%20stage%20with%20spotlight%2C%20breaking%20news%20concept%2C%20entertainment%20scandal%20atmosphere%2C%20dark%20theater%20backdrop%20with%20dramatic%20lighting&width=900&height=500&seq=carousel-01&orientation=landscape",
  },
  {
    id: 2,
    title: "选秀行业深度调查",
    subtitle: "光环背后的资本游戏与潜规则",
    excerpt: "独家揭秘选秀产业链背后的资本运作，从投票机制到合约陷阱，深度还原选秀行业的真实生态。",
    image: "https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20voting%20screens%2C%20behind%20the%20scenes%20entertainment%20industry%2C%20dramatic%20purple%20and%20gold%20lighting%2C%20show%20business%20atmosphere&width=900&height=500&seq=carousel-02&orientation=landscape",
  },
  {
    id: 3,
    title: "2026吃瓜年鉴",
    subtitle: "年度十大热门瓜事件完整回顾",
    excerpt: "从社交媒体删帖事件到剧组矛盾曝光，小编精心整理了本年度最具话题度的吃瓜事件，附详细时间线和人物关系图。",
    image: "https://readdy.ai/api/search-image?query=Newspaper%20headlines%20collage%20with%20dramatic%20lighting%2C%20entertainment%20news%20concept%2C%20warm%20amber%20and%20red%20tones%2C%20editorial%20design%20aesthetic&width=900&height=500&seq=carousel-03&orientation=landscape",
  },
  {
    id: 4,
    title: "代言风波全解析",
    subtitle: "品牌与艺人：一场高风险的商业博弈",
    excerpt: "当艺人负面新闻爆发，品牌方的应对策略和背后考量。从解约速度到公关话术，我们为你拆解品牌代言的全流程。",
    image: "https://readdy.ai/api/search-image?query=Luxury%20brand%20billboard%20being%20taken%20down%2C%20dramatic%20urban%20night%20scene%2C%20commercial%20photography%20style%2C%20warm%20city%20lights&width=900&height=500&seq=carousel-04&orientation=landscape",
  },
];

export const indexData = [
  { id: 1, title: "明星税务风波", count: 47, tag: "热门" },
  { id: 2, title: "综艺节目内幕", count: 35, tag: "持续更新" },
  { id: 3, title: "顶流恋情曝光", count: 29, tag: "最新" },
  { id: 4, title: "剧组矛盾揭秘", count: 23, tag: "" },
  { id: 5, title: "选秀黑幕调查", count: 21, tag: "深度" },
  { id: 6, title: "品牌代言风波", count: 18, tag: "" },
  { id: 7, title: "社交平台删帖", count: 16, tag: "跟进中" },
  { id: 8, title: "经纪公司内幕", count: 14, tag: "" },
  { id: 9, title: "假唱现场合集", count: 12, tag: "热议" },
];

export const featuresData = [
  {
    id: 1,
    icon: "ri-flashlight-line",
    title: "极速爆料",
    desc: "7×24小时全网监测，重大事件15分钟内响应推送，第一时间为您呈现最新瓜田动态与热点瓜追踪。",
  },
  {
    id: 2,
    icon: "ri-shield-check-line",
    title: "深度核实",
    desc: "专业团队多方交叉验证，每条信息标注来源类型与核实状态，拒绝谣言传播，让吃瓜更放心。",
  },
  {
    id: 3,
    icon: "ri-file-search-line",
    title: "独家挖掘",
    desc: "深度调查团队持续产出独家内容，从黑料内幕到瓜田爆料，不做搬运工只挖真内幕。",
  },
  {
    id: 4,
    icon: "ri-group-line",
    title: "千万瓜友",
    desc: "活跃的吃瓜社区氛围，和280万+日活用户一起讨论、分享、追踪最新最热的八卦事件。",
  },
];

export const mediaData = [
  {
    id: 1,
    title: "独家视频：某顶流工作室外实拍，律师团队紧急会议",
    duration: "03:21",
    views: "128万",
    image: "https://readdy.ai/api/search-image?query=Office%20building%20night%20exterior%20with%20lights%20on%2C%20law%20firm%20atmosphere%2C%20dramatic%20urban%20night%20photography%2C%20mysterious%20corporate%20scene&width=800&height=450&seq=media-01&orientation=landscape",
  },
  {
    id: 2,
    title: "综艺录制现场画面：嘉宾争执后离场全程",
    duration: "05:47",
    views: "96万",
    image: "https://readdy.ai/api/search-image?query=TV%20studio%20behind%20the%20scenes%2C%20empty%20stage%20with%20equipment%2C%20dramatic%20backstage%20lighting%2C%20entertainment%20industry%20photography&width=800&height=450&seq=media-02&orientation=landscape",
  },
  {
    id: 3,
    title: "品牌连夜撤换代言人广告牌，现场工人施工",
    duration: "02:15",
    views: "87万",
    image: "https://readdy.ai/api/search-image?query=Billboard%20being%20changed%20at%20night%2C%20construction%20workers%2C%20urban%20city%20scene%2C%20dramatic%20night%20photography%2C%20commercial%20district&width=800&height=450&seq=media-03&orientation=landscape",
  },
  {
    id: 4,
    title: "粉丝后援会联合发布会：要求经纪公司回应",
    duration: "08:32",
    views: "65万",
    image: "https://readdy.ai/api/search-image?query=Press%20conference%20with%20microphones%2C%20fan%20gathering%20atmosphere%2C%20indoor%20event%20photography%2C%20dramatic%20lighting%2C%20crowd%20scene&width=800&height=450&seq=media-04&orientation=landscape",
  },
  {
    id: 5,
    title: "深度解读：上半年娱乐圈大事件时间线梳理",
    duration: "12:06",
    views: "52万",
    image: "https://readdy.ai/api/search-image?query=Timeline%20infographic%20concept%2C%20news%20collage%2C%20editorial%20design%2C%20warm%20lighting%2C%20modern%20media%20presentation%20style&width=800&height=450&seq=media-05&orientation=landscape",
  },
];

export const contactData = {
  title: "联系我们",
  subtitle: "有猛料想爆料？有内幕要曝光？欢迎通过以下方式联系我们的编辑团队",
  email: "tips@wuyiheiliaowang.com",
  wechat: "wuyiheiliaowang",
};